<template>
  <div :idProfile="result.profile.id" class="profileMembres contenuPanel">
    <router-link :to="to">
      <div class="cadrePhoto image" @click="setLast">
        <Photo :profile="result.profile" :pic="result.profile.mainPicture" thumb />
        <ConnectedIcon :profile="result.profile" />
      </div>
    </router-link>
    <div class="info">
      <div>
        <Pseudo :profile="result.profile" />
        <div>{{ result.profile.age }} ans</div>
      </div>

      <div class="ville">{{ result.profile.city.name }}{{ depCode }}<br />{{ result.profile.city.country.name }}</div>

      <span v-if="result.alert" class="flashLe"> {{ $parent.$parent.alertName }} le {{ result.formattedDate }} </span>

      <div class="boutons">
        <MessageButton :profile="result.profile" :disabled="$store.state.profile.validated == false" />
        <FlashButton :profile="result.profile" :disabled="$store.state.profile.validated == false" />
      </div>
    </div>

    <div class="deleteButton" v-if="deleteButton">
      <img :src="'/assets/icons_' + $store.state.iconTheme + '/cross2.png'" @click="del" />
    </div>

    <div class="description" v-html="profileDescription"></div>
  </div>
</template>

<script>
import ConnectedIcon from "@/components/profile/ConnectedIcon";
import MessageButton from "@/components/buttons/MessageButton";
import FlashButton from "@/components/buttons/FlashButton";
import Photo from "@/components/profile/Photo";
import BaseProfileBox from "@/components/util/BaseProfileBox";
import Pseudo from "@/components/profile/Pseudo";

export default {
  name: "LargeProfileBox",
  components: { ConnectedIcon, MessageButton, FlashButton, Photo, Pseudo },
  extends: BaseProfileBox,
  data() {
    return {};
  },

  methods: {
    del() {
      this.$emit("onDelete", this.result, this.index);
    },

    setLast() {
      this.$store.commit("setLastResultIndex", this.index);
    }
  },

  computed: {
    profileDescription() {
      return this.result.profile.shortDescription || this.result.profile.longDescription || "";
    },

    largeMode() {
      return true;
    },

    to: function() {
      const res = {
        name: "Profil",
        query: {
          p: this.result.profile.pseudo
        }
      };
      return res;
    },

    depCode: function() {
      if (this.result.profile.city.department == null) return "";

      const code = this.result.profile.city.department.code;
      if (code) return " (" + code + ")";
      return "";
    }
  }
};
</script>

<style lang="scss" scoped>
@import "@/assets/css/util.scss";
@import "@/assets/css/vars.scss";

.profileMembres {
  position: relative;
  display: grid;
  grid-template-columns: min-content auto;
  grid-gap: 10px;
  border-width: 1px;
  border-color: #ccc;
  border-style: solid;
  padding: 5px;
  box-shadow: $mid_shadow;
}

.description {
  display: none;
}

.texte {
  max-height: 80px;
  overflow: hidden;
  font-size: 14px;
}

.info {
  position: relative;
  display: grid;
  grid-gap: 10px;
  grid-template-rows: min-content min-content 1fr;
  align-items: end;
  align-content: end;
}

p {
  margin: 0px;
  padding: 0px;
}

.croixSupprimer {
  position: absolute;
  top: -2px;
  right: -5px;
  cursor: pointer;
}

.boutons {
  display: grid;
  grid-template-columns: min-content min-content min-content;
  grid-gap: 10px;
  border-top: $light_border;
  padding-top: 5px;
}

.boutons .imageBouton {
  width: auto !important;
}

.flashLe {
  font-style: italic;
  color: #aaa;
  font-weight: normal;
  font-size: 12px;
  display: inline-block;
  margin-top: 5px;
}

@media screen and (max-width: 600px) {
  .texte {
    display: none;
  }

  .cadrePhoto {
    height: 160px;
    width: 120px;
  }

  .profileMembres > .flashLe {
    display: none;
  }
}

img.connected {
  position: absolute;
  bottom: 0px;
  right: 0px;
}

.deleteButton {
  position: absolute;
  top: 0;
  right: 0;
  cursor: pointer;
  img {
    width: 20px;
  }
}

@media screen and (min-width: 800px) {
  .largeMode {
    .profileMembres {
      grid-template-columns: min-content 150px 1fr;
    }

    .description {
      display: block;
      border-left: 1px #ddd solid;
      padding-left: 10px;
      padding: 10px;
      overflow-y: scroll;
      max-height: 170px;
    }
  }
}
</style>
